import React from "react";
import { Link } from "react-router-dom";
import UniverseDecoderLogo from "../../assets/icons/universedecoder-logo.svg";
import "./styles.css";

const About = () => {
  return (
    <main className="ud-about-page">
      <header className="ud-about-header">
        <Link to="/" className="ud-about-brand">
          <img src={UniverseDecoderLogo} alt="" />
          <span>
            Universe<span>decoder.</span>
          </span>
        </Link>

        <Link to="/" className="ud-about-home">
          ← Back to home
        </Link>
      </header>

      <article className="ud-about-content">
        <span className="ud-about-eyebrow">ABOUT UNIVERSEDECODER</span>

        <h1>
          Everyday challenges.
          <br />
          <span>Thoughtful solutions.</span>
        </h1>

        <p className="ud-about-intro">
          Universedecoder is built around a simple idea: technology should make
          everyday life easier.
        </p>

        <p>
          We create practical apps and digital tools that help people stay
          organised, build consistency, and see their progress. Our focus is on
          clear design and useful features that serve a real purpose.
        </p>

        <section className="ud-about-section">
          <h2>What we offer</h2>

          <p>
            Our first offering, Muscle Up, brings structure to your fitness
            journey. As a workout tracker and gym log, it helps you record your
            training and follow your progress over time.
          </p>

          <p>
            As Universedecoder grows, our aim is to bring that same thoughtful
            approach to more everyday needs.
          </p>

          <Link to="/muscleUp" className="ud-about-product-link">
            Discover Muscle Up <span aria-hidden="true">→</span>
          </Link>
        </section>

        <section className="ud-about-section">
          <h2>Our philosophy</h2>

          <p className="ud-about-philosophy">
            Keep things clear. Make them useful. Keep improving.
          </p>

          <p>
            Every product starts with a problem worth solving—and the belief that
            the solution should be simple to use.
          </p>
        </section>
      </article>

      <footer className="ud-about-footer">
        <span>© 2026 UNIVERSEDECODER</span>
        <span>BUILT WITH PURPOSE</span>
      </footer>
    </main>
  );
};

export default About;